<template>
  <mds-alert
    v-if="showAlert"
    v-bind:variation="alertVariation"
    v-bind:title="alertTitle"
    tinted
    @mds-alert-dismissed="closeAlert"
  >
    {{ alertMessage }}
  </mds-alert>

  
  <!-- Loader Overlay -->
  <div
    v-if="showLoader"
    style="
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(255,255,255,0.7);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <mds-loader size="large" />
  </div>
  <div style="display: flex; justify-content: center; align-items: flex-start; min-height: 80vh; width: 100%;">


   <mds-card
      style="max-width: 1100px; width: 100%; margin-top: 1%;"
      title="Keywords Management"
      caption="Manage keywords for companies"
    >
    <template #mds-card-action>
      <!-- Tab Navigation -->
      <div style="margin-bottom: 20px; border-bottom: 2px solid #e0e0e0;">
        <mds-button
          :class="activeTab === 'single' ? 'active-tab' : 'tab-button'"
          @click="switchTab('single')"
          variation="secondary"
          style="margin-right: 10px; margin-bottom: 10px;"
        >
          Single Company
        </mds-button>
        <mds-button
          :class="activeTab === 'multiple' ? 'active-tab' : 'tab-button'"
          @click="switchTab('multiple')"
          variation="secondary"
          style="margin-bottom: 10px;"
        >
          Multiple Companies
        </mds-button>
      </div>

      <!-- Single Company Tab -->
      <div v-if="activeTab === 'single'">
        <mds-form>
<mds-fieldset style="display: flex; align-items: center; gap: 1rem; margin-bottom: 20px;">
            <mds-input
    style="min-width: 200px; height: 40px;"
              label="Company ID"
              v-model="searchCompanyId"
              placeholder="Enter Company ID"
            ></mds-input>
            <mds-button
              variation="primary"
              icon="search"
              @click="searchCompany"
              :disabled="showLoader"
    style="height: 40px; min-width: 110px; font-size: 16px; border-radius: 8px; margin-left: 0;"

            >
              Search
            </mds-button>
          </mds-fieldset>
        </mds-form>

        <!-- Company Details & Keywords Grid -->
        <div v-if="selectedCompany">
<mds-card style="margin-bottom: 20px; max-width: 900px; width: 100%;">
  <template #mds-card-header>
    <h3>Company: {{ selectedCompany.companyName }} (ID: {{ selectedCompany.companyId }})</h3>
  </template>
  <template #mds-card-action>
    <div style="margin-bottom: 20px;">
      <label style="font-weight: bold; margin-bottom: 10px; display: block;">
        Keywords ({{ keywordsText.length }}/3500 characters):
      </label>
   <textarea
  v-model="keywordsText"
  placeholder="Enter keywords separated by commas"
  style="
    width: 100%;
    height: 150px;
    padding: 14px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-family: inherit;
    font-size: 16px;
    resize: vertical;
    overflow-x: auto;
    overflow-y: auto;
    white-space: pre-wrap;
    background: #fafbfc;
  "
></textarea>
      <div style="margin-top: 10px;">
        <span 
          :style="{ color: keywordsText.length > 3500 ? '#ff4444' : '#666' }"
          style="font-size: 12px;"
        >
          Character count: {{ keywordsText.length }}/3500
        </span>
      </div>
    </div>
    <mds-button
      variation="primary"
      @click="handleKeywordAction"
      :disabled="showLoader || keywordsText.length > 3500"
    >
    {{ keywordsText && keywordsText.trim().length > 0 ? (isNewKeyword ? 'Add Keyword' : 'Update Keyword') : 'Add Keyword' }}
    </mds-button>
  </template>
</mds-card>
        </div>
      </div>

      <!-- Multiple Companies Tab -->
      <div v-if="activeTab === 'multiple'">
        <mds-card>
          <template #mds-card-header>
            <h3>Bulk Keywords Update</h3>
          </template>
          <template #mds-card-action>
            <!-- Download Template -->
            <div style="margin-bottom: 20px; padding: 15px; background-color: #f8f9fa; border-radius: 8px;">
              <h4>Step 1: Download Template</h4>
              <p>Download the Excel template and fill in your company IDs and keywords.</p>
              <mds-button
                variation="secondary"
                icon="download"
                @click="downloadTemplate"
              >
                Download Template
              </mds-button>
            </div>

            <!-- Upload File -->
            <div style="margin-bottom: 20px; padding: 15px; background-color: #f8f9fa; border-radius: 8px;">
              <h4>Step 2: Upload Filled Template</h4>
              <p>Upload your completed Excel file with company IDs and keywords.</p>
              <input
                type="file"
                ref="fileInput"
                @change="handleFileUpload"
                accept=".xlsx,.xls"
                style="margin-bottom: 10px;"
              />
              <div v-if="uploadedFile" style="margin-top: 10px;">
                <span style="color: #28a745; font-weight: bold;">
                  File selected: {{ uploadedFile.name }}
                </span>
              </div>
            </div>

            <!-- Upload Button -->
            <mds-button
              variation="primary"
              @click="processBulkUpload"
              :disabled="!uploadedFile || showLoader"
            >
              {{ showLoader ? 'Processing...' : 'Process Bulk Update' }}
            </mds-button>

            <!-- Upload Results -->
            <div v-if="uploadResults.length > 0" style="margin-top: 20px;">
              <h4>Upload Results:</h4>
              <mds-table>
                <mds-thead>
                  <mds-th>Company ID</mds-th>
                  <mds-th>Status</mds-th>
                  <mds-th>Message</mds-th>
                </mds-thead>
                <mds-tbody>
                  <mds-tr v-for="result in uploadResults" :key="result.companyId">
                    <mds-td>{{ result.companyId }}</mds-td>
                    <mds-td>
                      <span :style="{ color: result.success ? '#28a745' : '#dc3545' }">
                        {{ result.success ? 'Success' : 'Failed' }}
                      </span>
                    </mds-td>
                    <mds-td>{{ result.message }}</mds-td>
                  </mds-tr>
                </mds-tbody>
              </mds-table>
            </div>
          </template>
        </mds-card>
      </div>

   
    </template>
  </mds-card>
   </div>
</template>

<script>
import axiosInstance from "@/AxiosTokenInstance";
import MdsCard from "@mds/card-vue3";
import MdsForm from "@mds/form-vue3";
import MdsInput from "@mds/input-vue3";
import MdsFieldset from "@mds/fieldset-vue3";
import { MdsButton } from "@mds/button-vue3";
import MdsLoader from "@mds/loader-vue3";
import MdsAlert from "@mds/alert-vue3";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table-vue3";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import config from "../../config";

export default {
  name: "KeywordsManagement",
  components: {
    MdsCard,
    MdsForm,
    MdsInput,
    MdsFieldset,
    MdsButton,
    MdsLoader,
    MdsAlert,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
  },
  data() {
    return {
      activeTab: 'single',
      searchCompanyId: '',
      selectedCompany: null,
      keywordsText: '',
      uploadedFile: null,
      uploadResults: [],
      showLoader: false,
      showAlert: false,
      alertTitle: '',
      alertMessage: '',
      alertVariation: '',
      alertTimer: null,
      isNewKeyword: false, // Track if it's a new keyword or update
    };
  },
   watch: {
    selectedCompany(newVal) {
      // If no keywords, set isNewKeyword to true
      if (newVal && (!newVal.keywords || newVal.keywords.trim() === "")) {
        this.isNewKeyword = true;
        this.keywordsText = "";
      } else {
        this.isNewKeyword = false;
        this.keywordsText = newVal ? newVal.keywords : "";
      }
    }
  },
   computed: {
    keywordsArray() {
      return this.keywordsText
        .split(',')
        .map(k => k.trim())
        .filter(k => k.length > 0);
    },
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      this.resetData();
    },

    resetData() {
      this.searchCompanyId = '';
      this.selectedCompany = null;
      this.keywordsText = '';
      this.uploadedFile = null;
      this.uploadResults = [];
      this.closeAlert();
    },

 async searchCompany() {
  if (!this.searchCompanyId.trim()) {
    this.setAlert(true, "Warning", "Please enter a Company ID", "warning");
    return;
  }

  this.showLoader = true;
  try {
    const response = await axiosInstance.get(
      `${config.api_url}ManageKeyword/GetCompanyKeywords/${this.searchCompanyId}`
    );

    if (response.data.success) {
      if (response.data.data && response.data.data.keywords !== undefined) {
        this.selectedCompany = response.data.data;

        this.keywordsText = this.selectedCompany.keywords || '';

        this.isNewKeyword =false;
      } else {
        this.selectedCompany = this.searchCompanyId;
        this.keywordsText = "";
        this.isNewKeyword = true;
       this.setAlert(true, "Warning", "No keywords found for this Company ID", "warning");
      }
    } else {
      this.setAlert(true, "Error", response.data.message, "error");
      this.selectedCompany = null;
      this.keywordsText = "";
      this.isNewKeyword = true;
    }
  } catch (error) {
    this.setAlert(true, "Error", "Failed to fetch company data", "error");
    this.selectedCompany = null;
    this.keywordsText = "";
    this.isNewKeyword = true;
  } finally {
    this.showLoader = false;
  }
},

    validateKeywords(keywords) {
      const errors = [];
      
      if (keywords.length > 3500) {
        errors.push("Keywords exceed 3500 character limit");
      }
     
      return errors;
    },
 async handleKeywordAction() {
      const validationErrors = this.validateKeywords(this.keywordsText);
      if (validationErrors.length > 0) {
        this.setAlert(true, "Validation Error", validationErrors.join(", "), "error");
        return;
      }

      this.showLoader = true;
      try {
        let response;
        if (this.isNewKeyword) {
          // POST for new keyword
          response = await axiosInstance.post(
            `${config.api_url}ManageKeyword/AddCompanyKeywords`,
            {
              CompanyId: this.searchCompanyId,
              Keyword: this.keywordsText.trim(),
            }
          );
        } else {
          // PUT for update
          response = await axiosInstance.put(
            `${config.api_url}ManageKeyword/UpdateCompanyKeywords`,
            {
              CompanyId: this.searchCompanyId,
              Keyword: this.keywordsText.trim(),
            }
          );
        }

        if (response.data.success) {
          this.setAlert(true, "Success", this.isNewKeyword ? "Keywords added successfully" : "Keywords updated successfully", "success");
          this.isNewKeyword = false;
        } else {
          this.setAlert(true, "Error", response.data.message, "error");
        }
      } catch (error) {
        this.setAlert(true, "Error", "Failed to save keywords", "error");
      } finally {
        this.showLoader = false;
      }
    },
    async saveKeywords() {
      const validationErrors = this.validateKeywords(this.keywordsText);
      if (validationErrors.length > 0) {
        this.setAlert(true, "Validation Error", validationErrors.join(", "), "error");
        return;
      }

      this.showLoader = true;
      try {
        const response = await axiosInstance.post(
          `${config.api_url}ManageKeyword/UpdateCompanyKeywords`,
          {
            companyId: this.selectedCompany.companyId,
            keywords: this.keywordsText.trim(),
          }
        );

        if (response.data.success) {
          this.setAlert(true, "Success", "Keywords updated successfully", "success");
        } else {
          this.setAlert(true, "Error", response.data.message, "error");
        }
      } catch (error) {
        this.setAlert(true, "Error", "Failed to save keywords", "error");
      } finally {
        this.showLoader = false;
      }
    },

    downloadTemplate() {
      // Create Excel template
      const templateData = [
        ['Company ID', 'Keywords']
        
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(templateData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Keywords Template');

      // Set column widths
      worksheet['!cols'] = [
        { wch: 15 }, // Company ID column
        { wch: 80 }  // Keywords column
      ];

      // Generate Excel file
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'keywords-template.xlsx');
    },

    handleFileUpload(event) {
      this.uploadedFile = event.target.files[0];
      this.uploadResults = [];
    },

    async processBulkUpload() {
      if (!this.uploadedFile) {
        this.setAlert(true, "Warning", "Please select a file to upload", "warning");
        return;
      }

      this.showLoader = true;
      this.uploadResults = [];

      try {
        const fileData = await this.readExcelFile(this.uploadedFile);
        const validationResults = this.validateExcelData(fileData);

        if (validationResults.hasErrors) {
          this.uploadResults = validationResults.results;
          this.setAlert(true, "Validation Error", "Please fix the errors in your file", "error");
          return;
        }
const payload = validationResults.validData.map(row => ({
    CompanyId: row.companyId,
    Keyword: row.keywords,
  }));
const response = await axiosInstance.put(
    `${config.api_url}ManageKeyword/UpdateAddBulkCompanyKeywords`,
    payload
  );
// The API returns results per company
if (response.data && response.data.data && response.data.data.results) {
  this.uploadResults = response.data.data.results.map(r => ({
      companyId: r.companyId,
      success: r.success,
      message: r.message
    }));
  }else if (
  response.data &&
  response.data.message &&
  response.data.message.includes('out of coverage')
) {
  // Extract company IDs from the error message
  const match = response.data.message.match(/out of coverage:([\s\S]*)/i);
  let ids = [];
  if (match && match[1]) {
    ids = match[1].split(',').map(id => id.trim());
  }
  this.uploadResults = ids.map(id => ({
    companyId: id,
    success: false,
    message: 'Company ID is out of coverage'
  }));
} 
  else {
    // fallback if API returns error
    this.uploadResults = [{
      companyId: '',
      success: false,
      message: response.data.message || 'Bulk update failed'
    }];
  }

  const successCount = this.uploadResults.filter(r => r.success).length;
  const totalCount = this.uploadResults.length;

  this.setAlert(
    true,
    "Process Complete",
    `${successCount} out of ${totalCount} companies updated successfully`,
    successCount === totalCount ? "success" : "warning"
  );
} catch (error) {
  this.setAlert(true, "Error", "Failed to process file", "error");
} finally {
  this.showLoader = false;
  this.uploadedFile = null;
  if (this.$refs.fileInput) {
    this.$refs.fileInput.value = '';
  }
}

    },

    readExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            resolve(jsonData);
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },

    validateExcelData(data) {
      const results = [];
      const validData = [];
      let hasErrors = false;
  const companyIdCount = {}; 

      for (let i = 1; i < data.length; i++) {
        const row = data[i];
        const companyId = row[0]?.toString().trim();
        const keywords = row[1]?.toString().trim() || '';
  if ((!companyId || companyId === '') && (!keywords || keywords === '')) {
    continue;
  }
  if (companyId) {
      companyIdCount[companyId] = (companyIdCount[companyId] || 0) + 1;
    }
        if (!companyId) {
    hasErrors = true;
    results.push({
      companyId: '(empty)',
      success: false,
      message: 'Company ID cannot be empty'
    });
    continue;
  }

        const validationErrors = this.validateKeywords(keywords);
        
        if (validationErrors.length > 0) {
          hasErrors = true;
          results.push({
            companyId: companyId || '(empty)',
            success: false,
            message: validationErrors.join(', ')
          });
        } else {
          validData.push({ companyId, keywords });
        }
      }
  Object.keys(companyIdCount).forEach(id => {
    if (companyIdCount[id] > 1) {
      hasErrors = true;
      results.push({
        companyId: id,
        success: false,
        message: 'Company ID exists more than once in the file'
      });
    }
  });
      return { results, validData, hasErrors };
    },

    setAlert(flag, title, message, variation) {
      this.showAlert = flag;
      this.alertTitle = title;
      this.alertMessage = message;
      this.alertVariation = variation;
      
      if (flag) {
        window.scrollTo(0, 0);
        this.autoCloseAlert();
      }
    },

    closeAlert() {
      this.showAlert = false;
      this.alertTitle = '';
      this.alertMessage = '';
      this.alertVariation = '';
      if (this.alertTimer) {
        clearTimeout(this.alertTimer);
        this.alertTimer = null;
      }
    },

    autoCloseAlert() {
      this.alertTimer = setTimeout(() => {
        this.closeAlert();
      }, 5000);
    },
  },
};
</script>

<style scoped>
.mds-alert--info {
  background-color: #e6f0fa !important; /* Light blue */
  color: #155fa0 !important;            /* Dark blue text */
  border-left: 5px solid #2196f3 !important; /* Blue border */
}
.active-tab {
  background-color: #0066cc !important;
  color: white !important;
  border-bottom: 3px solid #0066cc;
}

.tab-button {
  background-color: #f8f9fa;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  background-color: #e9ecef;
}

/* Custom scrollbar for textarea */
textarea::-webkit-scrollbar {
  width: 8px;
}

textarea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

textarea::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

textarea::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>